module.exports = __webpack_public_path__ + "img/engineer-logo-3-active.72d1137a.png";